import 'babel-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import PcSurvey from '@src/pc/survey';
import PcComment from '@src/pc/comment';
import PcPlayer from '@src/pc/video';
import HardAd from '@src/pc/hardAd';
import MobileSurvey from '@src/mobile/survey';
import MobileComment from '@src/mobile/comment';
import MobilePlayer from '@src/mobile/video';
import WXShare from '@src/mobile/share';

const compObj = {
    pcSurvey: PcSurvey,
    pcComment: PcComment,
    pcPlayer: PcPlayer,
    hardAd: HardAd,
    mobileSurvey: MobileSurvey,
    mobileComment: MobileComment,
    mobilePlayer: MobilePlayer,
    WXShare,
};

const compRender = comp => (dom, config) => {
    const Componment = compObj[comp];

    ReactDOM.render(<Componment config={config} />, dom);
};

window.pcSurvey = compRender('pcSurvey');
window.pcComment = compRender('pcComment');
window.pcPlayer = compRender('pcPlayer');
window.hardAd = compRender('hardAd');

window.mobileSurvey = compRender('mobileSurvey');
window.mobileComment = compRender('mobileComment');
window.mobilePlayer = compRender('mobilePlayer');
window.WXShare = compRender('WXShare');
